export enum SubEventProgressRowKind {
  CHECKPOINT = 'CHECKPOINT',
  IN_BETWEEN = 'IN_BETWEEN',
}

export enum SubEventProgressTimeKind {
  ACTUAL = 'ACTUAL',
  PREDICTED = 'PREDICTED',
  NONE = 'NONE',
}

export type SubEventProgressProportionSegments = {
  onCourse: number;
  finished: number;
  remainder: number;
};

export type SubEventProgressRow = {
  kind: SubEventProgressRowKind;
  label: string;
  passedCount: number | null;
  startedCount: number;
  passedPercentage: number | null;
  gapCount: number | null;
  gapPercentage: number | null;
  firstTime: string | null;
  firstTimeKind: SubEventProgressTimeKind;
  lastTime: string | null;
  lastTimeKind: SubEventProgressTimeKind;
  isAnomaly: boolean;
};

export type SubEventProgressOverview = {
  subEventId: string;
  name: string;
  resultsLastModifiedAt: string;
  startedCount: number;
  finishedCount: number;
  onCourseCount: number;
  expectedAtFinishCount: number;
  dnfCount: number;
  dqCount: number;
  dnsCount: number;
  onCoursePercentage: number | null;
  finishedPercentage: number | null;
  proportionSegments: SubEventProgressProportionSegments;
  checkpoints: SubEventProgressRow[];
};

/** `raceRosterEvent.progressOverview` from the public GraphQL API. */
export type EventProgressProgressOverview = {
  races: SubEventProgressOverview[];
};
